import { Outlet } from 'react-router-dom';

import NavigationShortcuts from '@layouts/navigation-shortcuts/navigation-shortcuts';
import Toast from '@ui/toast/toast';
import useReceiveMessage from './utils/embed/use-receive-message';
import useNoGridAnimationsOnNavigation from './utils/use-no-grid-animations-on-navigation';
import usePanelRevertTracker from './utils/use-panel-revert-tracker';

const App = () => {
  useReceiveMessage();

  useNoGridAnimationsOnNavigation();
  usePanelRevertTracker();

  return (
    <>
      <Outlet />
      <NavigationShortcuts />
      <Toast />
    </>
  );
};

export default App;
